<template>
    <div class="historico-page">
        <div class="mb-4 " @click="goBack" style="color: #136A9F; width: 100%; font-weight: bolder;">
            <span class='d-flex align-items-center back_button' @click="voltarParaLista">
                <el-icon color="#136A9F" style="font-size: 27px;">
                    <Back />
                </el-icon>
                Voltar
            </span>
        </div>
        <h1 class="losta_masca">Histórico do Congregado nº {{ num_ficha }}</h1>

        <div class="container-timeline">
            <template v-if="historico && historico.length > 0">
                <div v-for="(item, index) in historico" :key="index" style="display: flex;">
                    <div class="timeline_container">
                        <div style="text-align: center;">
                            <span class="timeline_content">{{ item.data_criacao }}</span> <br>
                            <span class="timeline_content" style="color: #8D99AE;">{{ item.hora_criacao }}</span>
                        </div>
                    </div>

                    <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
                        <div style="position: relative; display: flex; height: 100%; justify-content: center; align-items: center;">
                            <div
                                style="height: 12px; width: 12px; background-color: rgb(17, 76, 116); border-radius: 50%; z-index: 999;"
                            >
                            </div>
                            <div style="background-color: #e4e7ed; height: 100%; width: 3px; position: absolute; transform: translate(-50%, -50%); top: 50%; left: 50%;">
                            </div>
                        </div>

                        <div class="historico-card">
                            <strong style="color: #114C74;">{{ item.tipo }}</strong>
                            <p>{{ item.observacoes }}</p>
                            <strong style="color: #8D99AE;">{{ item.usuario_nome }}</strong>
                        </div>
                    </div>
                </div>
            </template>

            <div v-else style="text-align: center; padding: 200px 0; font-weight: bold; color: #8D99AE;">
                O congregado não possui nenhum registro de histórico
            </div>
        </div>
    </div>
</template>

<script>
import colheitaService from "@/services/colheitaService";
import { ElMessage } from "element-plus";

export default {
    name: "HistoricoPage",
    data() {
        return {
            user: this.$root.user || {},
            token: this.$root.token || {},
            num_ficha: this.$route.params.num_ficha ?? null,
            historico: [],
        };
    },
    async mounted() {
        await this.getHistory();
    },
    methods: {
        async getHistory() {
            const fichaId = this.$route.params.num_ficha;
            try {
                this.historico = await colheitaService.getHistory(fichaId, this.token);
            } catch (error) {
                ElMessage.error("Erro ao carregar histórico:");
            }
        },
        voltarParaLista() {
            this.$router.push(`/editar/${this.num_ficha}`);
        },
    },
};
</script>

<style scoped>
.historico-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
}

h2 {
    text-align: center;
    margin-bottom: 20px;
}

.historico-card {
    background-color: #fff;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    border: 1px solid #ebeef5;
    margin: 0;
    margin-bottom: 10px;
    margin-left: 10px;
    width: 100%;
}

.historico-card p {
    margin: 0;
    white-space: pre-line;
    /* mantém as quebras de linha do backend */
}

.timeline_container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 10px;
}

.timeline_content {
    text-align: center;
    font-weight: bolder;
    color: rgb(17, 76, 116);
}
</style>
